import React, { useEffect, useState } from "react";

export default function PersonalDetails({ report }) {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("+")[0].split("-");
    return `${day}-${month}-${year}`;
  };

  const identifications = [
    {
      type: "SocialId",
      number: report?.personal?.socialId || "N/A",
      issue: "-",
      expiry: "-",
    },
    {
      type: "TaxId",
      number: report?.personal?.pan || "N/A",
      issue: "-",
      expiry: "-",
    },
    {
      type: "CkycId",
      number: report?.personal?.ckyc || "N/A",
      issue: "-",
      expiry: "-",
    },
  ];

  const [phones, setPhones] = useState([]);
    const employments = report?.employment


  useEffect(() => {
    if (report?.personal?.allPhones) {
      const phoneList = report.personal.allPhones.map((element) => ({
        type: element?.PhoneType?.symbol || "01",
        number: element?.PhoneNumber?.Number,
        ext: "-",
      }));
      setPhones(phoneList);
    } else {
      // Fallback mock data to match image exactly if no report data is passed
      setPhones([
        { type: "01", number: "N/A", ext: "-" },

      ]);
    }
  }, [report?.personal?.allPhones]);

  // Fallback mock data to match image exactly
  const emails = report?.personal?.allEmails;


  // Fallback mock data to match image exactly
  const addresses = report?.personal?.allAddresses || [
    {
      CreditAddress: { StreetAddress: "N/A" },
      category: "N/A",
      residenceCode: "",
      dateReported: "N/A"
    },
   
  ];

  return (
    <div className="w-full max-w-5xl bg-white font-sans text-sm pb-2">
      
      {/* 1. IDENTIFICATION(S) SECTION */}
      <div className="mb-2 px-2">
        <h3 className="text-base text-gray-600 mb-1 mt-1 uppercase tracking-wide">
          IDENTIFICATION(S):
        </h3>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/4">
                IDENTIFICATION TYPE
              </th>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/4">
                IDENTIFICATION NUMBER
              </th>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/4">
                ISSUE DATE
              </th>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/4">
                EXPIRATION DATE
              </th>
            </tr>
          </thead>
          <tbody>
            {identifications.map((id, index) => (
              <tr
                key={index}
                className="odd:bg-[#E3E3E3] even:bg-white"
              >
                <td className="px-2 py-0.5 text-[9px] font-bold text-black capitalize">
                  {id.type}
                </td>
                <td className="px-2 py-0.5 text-[9px] font-bold text-black uppercase">
                  {id.number}
                </td>
                <td className="px-2 py-0.5 text-[9px] font-bold text-black">
                  {id.issue}
                </td>
                <td className="px-2 py-0.5 text-[9px] font-bold text-black">
                  {id.expiry}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Section Bottom Border */}
        <div className="h-[2px] bg-black mt-1"></div>
      </div>

      {/* 2. TELEPHONE(S) SECTION */}
      <div className="mb-2 px-2">
        <h3 className="text-base text-gray-600 mb-1 mt-1 uppercase tracking-wide">
          TELEPHONE(S):
        </h3>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/3">
                TELEPHONE TYPE
              </th>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/3">
                TELEPHONE NUMBER
              </th>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase w-1/3">
                TELEPHONE EXTENSION
              </th>
            </tr>
          </thead>
          <tbody>
            {phones.map((tel, index) => (
              <tr
                key={index}
                className="odd:bg-[#E3E3E3] even:bg-white"
              >
                <td className="px-2 py-0.5 text-[9px] font-medium text-black">
                  {tel.type}
                </td>
                <td className="px-2 py-0.5 text-[9px] font-medium text-black">
                  {tel.number}
                </td>
                <td className="px-2 py-0.5 text-[9px] font-medium text-black">
                  {tel.ext}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Section Bottom Border */}
        <div className="h-[2px] bg-black mt-1"></div>
      </div>

      {/* 3. EMAIL CONTACT(S) SECTION */}
      <div className="mb-2 px-2">
        <h3 className="text-base text-gray-600 mb-1 mt-1 uppercase tracking-wide">
          EMAIL CONTACT(S):
        </h3>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr>
              <th className="px-2 pb-1 text-[9px] font-bold text-[#00a1de] uppercase">
                EMAIL ADDRESS
              </th>
            </tr>
          </thead>
          <tbody>
                <tr
                  className="odd:bg-white even:bg-[#f7f8fa] border-b border-gray-200 last:border-0"
                >
                  <td className="px-4 py-3 text-[11px] font-bold text-black uppercase">
                    {emails?.["Email"] || "N/A"}
                  </td>
                </tr>
            </tbody>
        </table>
        {/* Section Bottom Border */}
        <div className="h-[2px] bg-black mt-1"></div>
      </div>

      {/* 4. ADDRESS(ES) SECTION */}
      <div className="mb-2 px-2">
        <h3 className="text-base text-gray-600 mb-1 mt-1 uppercase tracking-wide">
          ADDRESS(ES):
        </h3>
        <div className="flex flex-col">
          {addresses.map((addr, index) => (
            <div
              key={index}
              className={`flex flex-col py-1 px-2 ${
                index % 2 === 0 ? "bg-[#E3E3E3]" : "bg-white"
              }`}
            >
              {/* Address Line */}
              <div className="text-[9px] font-medium text-black uppercase mb-3 pr-8">
                ADDRESS : {addr?.CreditAddress?.StreetAddress || "N/A"}
              </div>
              {/* Meta Data Line */}
              <div className="flex justify-between w-full text-[9px] font-medium text-black uppercase pr-16">
                <div className="w-1/3">
                  CATEGORY: {addr?.category}
                </div>
                <div className="w-1/3 text-center">
                  RESIDENCE CODE: {addr?.residenceCode}
                </div>
                <div className="w-1/3 text-right">
                  {addr?.dateReported && `DATE REPORTED: ${addr?.dateReported}`}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Section Bottom Border */}
        <div className="h-[2px] bg-black mt-1"></div>
      </div>

    </div>
  );
}